import angularRedux from '@buildium/angular-redux';
import immutable from 'seamless-immutable';
import {FeatureFlagActionConstants as actions} from './action-names';

const reducers = {};
const initialState = immutable({
    featureFlags: {}
});

reducers[actions.SET_FEATURE_FLAG] = function setFeatureFlag(state, action) {
    return state.setIn(['featureFlags', action.flagKey], action.flagValue);
};

export const FeatureFlagsReducer = angularRedux.createState(initialState, reducers);
